import React, { useLayoutEffect } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import { LIQUIDATION_DIFFERENCE_REASON_PATH } from '../../../../config/paths';
import { clearLiquidationDifferenceReason, getLiquidationDifferenceReason } from '../../../../actions';
import Loader from '../../../common/Loader';
import Content from '../../../layout/Content';
import LiquidationDifferenceReasonToolbar from './LiquidationDifferenceReasonToolbar';
import NoDataResource from '../../../common/resource/NoDataResource';
import LiquidationDifferenceReasonBasicInformationResource from './resource/LiquidationDifferenceReasonBasicInformationResource';
import InternalResource from '../../../common/resource/InternalResource';

export const LiquidationDifferenceReason = ({
  breadcrumbs,
  match: {
    params: { id: liquidationDifferenceReasonId },
  },
  liquidationDifferenceReason,
  loading,
  dispatchGetLiquidationDifferenceReason,
  dispatchClearLiquidationDifferenceReason,
}) => {
  useLayoutEffect(() => {
    dispatchGetLiquidationDifferenceReason({ liquidationDifferenceReasonId });

    return () => dispatchClearLiquidationDifferenceReason();
  }, []);

  let content = null;
  let toolbar = null;
  if (loading) content = <Loader />;
  else if (liquidationDifferenceReason.isEmpty()) {
    content = <NoDataResource returnPage={LIQUIDATION_DIFFERENCE_REASON_PATH} />;
  } else {
    const liquidationDifferenceReasonJSON = liquidationDifferenceReason.toJS();
    content = (
            <>
              <h3>Información Básica</h3>
              <LiquidationDifferenceReasonBasicInformationResource {...liquidationDifferenceReasonJSON} />
              <InternalResource id={liquidationDifferenceReasonJSON.id}
                        createDate={liquidationDifferenceReasonJSON.createDate}
                        lastUpdate={liquidationDifferenceReasonJSON.lastUpdate}/>
            </>
      
  );
    toolbar = <LiquidationDifferenceReasonToolbar liquidationDifferenceReasonId={liquidationDifferenceReasonJSON.id} />;
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Discrepancia de Liquidación"
      toolbar={toolbar}
      content={content}
    />
  );
};

LiquidationDifferenceReason.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  liquidationDifferenceReason: PropTypes.instanceOf(Immutable.Map).isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  dispatchGetLiquidationDifferenceReason: PropTypes.func.isRequired,
  dispatchClearLiquidationDifferenceReason: PropTypes.func.isRequired,
};

LiquidationDifferenceReason.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Discrepancias de Liquidación',
      href: LIQUIDATION_DIFFERENCE_REASON_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  liquidationDifferenceReason: AccountingUnit.LiquidationDifferenceReason.getIn(['current', 'content']),
  loading: !AccountingUnit.LiquidationDifferenceReason.getIn(['current', 'activity']).isEmpty(),
});

const mapDispatchToProps = {
  dispatchGetLiquidationDifferenceReason: getLiquidationDifferenceReason,
  dispatchClearLiquidationDifferenceReason: clearLiquidationDifferenceReason,
};

export default connect(mapStateToProps, mapDispatchToProps)(LiquidationDifferenceReason);
